import * as React from 'react';
import BenchmarkContainer from 'containers/benchmark/BenchmarkContainer';

const Benchmark = () => {
  return <BenchmarkContainer />;
};

export default Benchmark;
